export default function Google() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8055 8.0415H19V8H10V12H15.6515C14.827 14.3285 12.6115 16 10 16C6.6865 16 4 13.3135 4 10C4 6.6865 6.6865 4 10 4C11.5295 4 12.921 4.577 13.9805 5.5195L16.809 2.691C15.023 1.0265 12.634 0 10 0C4.4775 0 0 4.4775 0 10C0 15.5225 4.4775 20 10 20C15.5225 20 20 15.5225 20 10C20 9.3295 19.931 8.675 19.8055 8.0415Z"
        fill="#FFC107"
      />
      <path
        d="M1.15332 5.3455L4.43882 7.755C5.32782 5.554 7.48082 4 10.0003 4C11.5298 4 12.9213 4.577 13.9808 5.5195L16.8093 2.691C15.0233 1.0265 12.6343 0 10.0003 0C6.15932 0 2.82832 2.1685 1.15332 5.3455Z"
        fill="#FF3D00"
      />
      <path
        d="M10.0002 20.0001C12.5832 20.0001 14.9302 19.0116 16.7047 17.4041L13.6097 14.7851C12.5721 15.5746 11.3039 16.0015 10.0002 16.0001C7.39916 16.0001 5.19066 14.3416 4.35866 12.0271L1.09766 14.5396C2.75266 17.7781 6.11366 20.0001 10.0002 20.0001Z"
        fill="#4CAF50"
      />
      <path
        d="M19.8055 8.0415H19V8H10V12H15.6515C15.2571 13.1082 14.5467 14.0766 13.608 14.7855L13.6095 14.7845L16.7045 17.4035C16.4855 17.6025 20 15 20 10C20 9.3295 19.931 8.675 19.8055 8.0415Z"
        fill="#1976D2"
      />
    </svg>
  );
}
